{
  "name": "@pantheon-systems/pcc-react-sdk",
  "author": "@pantheon-systems",
  "description": "Pantheon Content Publisher React SDK",
  "version": "5.1.0",
  "license": "MIT",
  "keywords": [
    "pcc",
    "react",
    "sdk",
    "pantheon"
  ],
  "homepage": "https://github.com/pantheon-systems/content-publisher-sdk/tree/main/nextjs-starter#readme",
  "repository": {
    "type": "git",
    "url": "https://github.com/pantheon-systems/content-publisher-sdk"
  },
  "scripts": {
    "dev": "tsup --watch",
    "build": "tsup",
    "type-check": "tsc --noEmit",
    "lint": "eslint . && prettier --check . && tsc --noEmit",
    "lint:fix": "eslint . --fix && prettier --write .",
    "test": "jest --coverage --passWithNoTests",
    "test:ci": "pnpm run test --ci",
    "update-snapshots": "pnpm run test --updateSnapshot",
    "test:watch": "jest --watch"
  },
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "require": "./dist/index.js",
      "import": "./dist/index.mjs"
    },
    "./components": {
      "types": "./dist/components/index.d.ts",
      "require": "./dist/components/index.js",
      "import": "./dist/components/index.mjs"
    },
    "./server": {
      "types": "./dist/server/index.d.ts",
      "require": "./dist/server/index.js",
      "import": "./dist/server/index.mjs"
    }
  },
  "typesVersions": {
    "*": {
      "*": [
        "./dist/index.d.ts"
      ],
      "components": [
        "./dist/components/index.d.ts"
      ]
    }
  },
  "files": [
    "dist"
  ],
  "engines": {
    "node": ">=18.10.0"
  },
  "devDependencies": {
    "@babel/core": "^7.25.2",
    "@babel/preset-env": "^7.25.3",
    "@babel/preset-react": "^7.24.7",
    "@babel/preset-typescript": "^7.24.7",
    "@testing-library/dom": "^10.4.0",
    "@testing-library/react": "16.3.0",
    "@types/jest": "29.5.1",
    "@types/lodash": "^4.17.15",
    "@types/node": "^20.11.21",
    "@types/react": "^19.1.8",
    "@types/react-dom": "^19.1.6",
    "babel-loader": "9.1.2",
    "chalk": "^5.3.0",
    "cli-spinners": "^2.9.2",
    "concurrently": "8.0.1",
    "eslint": "^8.57.0",
    "eslint-config-pcc-custom": "workspace:*",
    "jest": "29.5.0",
    "jest-environment-jsdom": "^30.0.4",
    "next": "^15.5.4",
    "octokit": "^3.2.1",
    "ora": "^6.3.1",
    "react": "19.1.0",
    "react-dom": "19.1.0",
    "ts-jest": "29.1.0",
    "tsup": "^8.2.4",
    "typescript": "^5.5.4",
    "yargs": "^17.7.2"
  },
  "peerDependencies": {
    "@types/react": ">=19",
    "@types/react-dom": ">=19",
    "react": ">=19",
    "react-dom": ">=9"
  },
  "peerDependenciesMeta": {
    "@types/react": {
      "optional": true
    }
  },
  "dependencies": {
    "@apollo/client": "^3.10.3",
    "@pantheon-systems/pcc-sdk-core": "workspace:*",
    "graphql": "^16.8.1",
    "lodash": "^4.17.21",
    "markdown-to-txt": "^2.0.1",
    "react-markdown": "^10.1.0",
    "rehype-raw": "^7.0.0",
    "remark-heading-id": "^1.0.1",
    "unist-util-visit": "^5.0.0"
  }
}
